import { createSvgComponent } from "../../icon/createSvgComponent";
import ArrowRoundRight from "@core/__generated__/icon/figma/arrow-round-right.svg";
export default createSvgComponent(ArrowRoundRight);